export default __webpack_public_path__ + "static/overseeding-fd50cf01832dc3770d05643be18e86e4.webp";